export const canOpenTableRow = event => {
  if (event?.defaultPrevented || event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey) return false;
  if (event?.target?.closest('a,button,input,select,textarea,label,[role="button"],[role="link"],[contenteditable="true"],[data-row-action]')) return false;
  return !window.getSelection?.()?.toString();
};

export const tableRowNavigation = open => ({
  tabIndex: 0,
  style: { cursor: 'pointer' },
  onClick: event => { if (canOpenTableRow(event)) open(); },
  onKeyDown: event => {
    if (event.key === 'Enter' && event.target === event.currentTarget && canOpenTableRow(event)) {
      event.preventDefault(); open();
    }
  },
});
